import React, { useEffect, useState } from 'react';
import { Widget } from '@digital/ui';
import { Steps } from 'antd';

import { GetTimeline } from '@app/api/boletimMedicao';
import { useRecoilState, useRecoilValue } from 'recoil';
import { medicaoIdState, medicaoSelectedState } from '../atoms';

const TimeLine = () => {
  const { Step } = Steps;
  const medicaoId = useRecoilValue(medicaoIdState);
  const [timeline, setTimeline] = useState({});

  useEffect(() => {
    if (medicaoId) GetTimeline(medicaoId).then(data => setTimeline(data));
  }, []);

  return (
    <>
      {timeline.steps ? (
        <Widget title="Timeline">
          <Steps direction="vertical" current={timeline.currentStep}>
            {timeline.steps.map((step, index) => (
              <Step key={`step_${index}`} title={step.title} />
            ))}
          </Steps>
        </Widget>
      ) : (
        <></>
      )}
    </>
  );
};

export default TimeLine;
